module.exports = __webpack_public_path__ + "img/product2.2491c969.png";